import classNames from 'classnames';
import React from 'react';
import I18n from 'i18n-js';
import { withRouter, WithRouterProps } from 'react-router';

import { withPrefix } from '../i18n_helpers';
import FacetOption from './facet_option';
import { FilterOption } from './search_filters';
import FilterLink from './filter_link';
import { MParticleEvent } from '../elog/mparticle_types';
import ProximityModal, { POSTAL_CODE_PARAM, DISTANCE_PARAM, MILES_100 } from './proximity_modal';
import { useUser } from '../user_hooks';

interface IExternalProps {
  option: FilterOption;
  onClick?: Function;
  linkParams?: any;
  clickEvent?: MParticleEvent;
  trackInteraction?: Function;
  inSortContext?: boolean;
}

type IProps = IExternalProps & WithRouterProps;

const t = withPrefix('commons.proximityFilter');

export const PROXIMITY_PARAM = 'proximity';
export const PROXIMITY_SORT_ASCENDING = 'proximity|asc';

function proximityParams(linkParams, postalCode, distance) {
  return {
    [POSTAL_CODE_PARAM]: postalCode,
    [DISTANCE_PARAM]: distance,
    ...linkParams,
  };
}

function handleClick(event, postalCode, openModal) {
  if (!postalCode) {
    event.preventDefault();
    openModal(true);
  }
}

export function ProximityFacet(props: IProps) {
  const user = useUser();
  const [modal, openModal] = React.useState(false);
  const { option, linkParams, clickEvent, location, trackInteraction, inSortContext = false } = props;
  const inFilterContext = !inSortContext;

  const linkClass = classNames({
    facet__link: true,
    'facet__link--checkbox': inFilterContext,
    'facet__link--active': option.selected,
  });

  const currentPostalCode = location?.query?.postal_code || user.postalCode;
  const currentDistance = location?.query?.distance || MILES_100;

  const proximityFilterText = currentPostalCode ?
    I18n.t('commons.proximityFilter.filterNameWithZip', {
      distance: currentDistance,
      postalCode: currentPostalCode,
    }) :
    I18n.t('commons.proximityFilter.filterName', {
      distance: currentDistance,
    });

  return (
    <>
      <FacetOption
        paramName="proximity"
        active={option.selected}
      >
        <FilterLink
          className={linkClass}
          params={proximityParams(linkParams, currentPostalCode, currentDistance)}
          data-checked={option.selected || null}
          rel="nofollow"
          clickEvent={clickEvent}
          onClick={(e) => handleClick(e, currentPostalCode, openModal)}
          trackInteraction={trackInteraction}
        >
          <div>
            {proximityFilterText}
            <button
              type="button"
              className="button-as-link ml-space"
              onClick={(e) => {
                e.preventDefault();
                openModal(true);
              }}
            >
              <span className="size-80 weight-bold">
                {t('modalButton')}
              </span>
            </button>
          </div>
        </FilterLink>
      </FacetOption>
      <ProximityModal
        isModalOpen={modal}
        setModal={openModal}
        propsPostalCode={currentPostalCode}
        propsDistance={currentDistance}
        includeRadiusDropdown={inFilterContext}
        additionalQueryParams={inSortContext ? { sort: PROXIMITY_SORT_ASCENDING } : { [PROXIMITY_PARAM]: true }}
        shouldApplyDistanceQueryParam={inFilterContext}
        shouldApplyPostalCodeQueryParam
      />
    </>
  );
}

export default withRouter(ProximityFacet);
